<template>
  <div class="faq-container">
    <div
      class="title-box"
      :class="[isFaqContentVisible ? 'is-orange' : 'is-grey']"
    >
      <h1 class="title" @click="toggleFaqContentVisibility()">FAQ</h1>
    </div>
    <div class="faq-content" v-show="isFaqContentVisible">
      <div class="question-answer">
        <h2>Qual canal utilizar para a solicitação de devolução?</h2>
        <p>
          Caso as peças de sua solicitação de devolução estejam atreladas a uma
          ordem de serviços, solicite sua devolução via canal Keppler. Caso
          contrário utilize o portal de solicitação de devolução.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          Qual o procedimento para solicitação de devolução de compressores
          EMBRACO?
        </h2>
        <p>
          As solicitações de devolução referentes a compressores EMBRACO devem
          ser feitas via portal de devolução e acompanhadas de certificado de
          garantia preenchido e nota fiscal de venda para o cliente final, essas
          informações serão pedidas no momento de sua solicitação.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          Qual o procedimento para solicitação de devolução por motivo de código
          trocado?
        </h2>
        <p>
          As solicitações por motivo de código trocado devem ser feitas via
          portal de devolução é necessário encaminhar a foto da peça recebida e
          etiqueta da caixa, essas informações serão pedidas no momento de sua
          solicitação.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          Qual o procedimento para solicitação de devolução por motivo de erro
          de catálogo?
        </h2>
        <p>
          As solicitações por motivo de erro de catálogo devem ser feitas via
          portal de devolução é necessário encaminhar Modelo do Produto/Número
          de Série/Versão de Engenharia, essas informações serão pedidas no
          momento de sua solicitação.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          Qual o prazo para solicitação de devolução por motivo de avaria?
        </h2>
        <p>
          Quando é recebido uma peça com avaria isto é, com a estética
          danificada, o prazo para solicitação de devolução é de até 5 dias
          úteis após o prazo de entrega, conforme política de devolução.
        </p>
      </div>
      <div class="question-answer">
        <h2>O que fazer após receber o número da OI?</h2>
        <p>
          Após o recebimento da ordem inversa, emita a nota fiscal de devolução
          e verifique data agendada para coleta no portal de devolução.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          Para onde para enviar as notas fiscais de devolução referente as peças
          não coletáveis?
        </h2>
        <p>
          Após a confirmação de que sua peça não será coletada, emita a nota
          fiscal de devoção e envie para os e-mails: devolucao_usp@whirlpool.com
          ; gcg-envioNFD_correios@whirlpool.com
        </p>
      </div>
      <div class="question-answer">
        <h2>Quando a devolução gera reenvio?</h2>
        <p>
          As solicitações de devolução somente gerarão reenvio de peças quando a
          nota fiscal informada tratar-se de uma nota fiscal LD - Livre de
          débito. Caso contrário será necessário realizar um novo pedido de
          peças.
        </p>
      </div>
      <div class="question-answer">
        <h2>Quando o valor da devolução será creditado?</h2>
        <p>
          Você pode acompanhar o processo de faturamento da peça através do
          próprio portal de devolução.
        </p>
      </div>
      <div class="question-answer">
        <h2>
          O que fazer quando emitir a nota fiscal de devolução com divergência?
        </h2>
        <p>
          Caso verifique que emitiu a nota fiscal com divergência entre em
          contato pelo e-mail
          <strong>mdl-mtjlle-logistica-reversa@whirlpool.com</strong> encaminhe
          a cópia da nota fiscal e o número da ordem inversa e informe a
          divergência encontrada.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
  data: function() {
    return {
      isFaqContentVisible: false,
      titleColor: "$grey3"
    };
  },
  methods: {
    toggleFaqContentVisibility() {
      this.isFaqContentVisible = !this.isFaqContentVisible;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.faq-container {
  width: 100%;

  .title-box {
    border-left: 4px solid $grey2;
    border-bottom: 1px solid $grey4;
    padding: 0 0 2px 5px;
    margin-top: 30px;
    width: 100%;

    .title {
      margin: 0;
      font-weight: 500;
      cursor: pointer;
    }

    &:hover {
      border-left-color: $orange1;
    }
  }

  .is-orange {
    border-left-color: $orange1;
  }

  .is-grey {
    // border-left-color: $grey2;
    background-color: #9e9e9e;
  }

  .faq-content {
    width: 100%;

    .question-answer {
      background: $grey4;
      padding: 1%;
      margin: 15px 0 15px 0;
      width: 98%;

      h2 {
        color: $orange1;
      }
    }
  }
}
</style>
